import React from "react";
import { motion } from "framer-motion";

export const PageHero = ({ overline, title, subtitle, testId = "page-hero" }) => {
  return (
    <section className="relative pt-40 pb-16 md:pb-24 border-b border-white/10 grid-lines overflow-hidden" data-testid={testId}>
      <div className="absolute inset-0 bg-gradient-to-b from-[#11151C]/60 to-[#0A0D12]" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-4 mb-6">
            <span className="w-10 h-px bg-[#C8A45A]" />
            <span className="overline">{overline}</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08] tracking-tight text-white">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-8 text-lg text-[#A1A5AB] leading-relaxed max-w-2xl">{subtitle}</p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
